import React from 'react';

import HelpTip from 'v2/components/Shared/HelpTip';
import { Space } from 'v2/components/Shared/Space';

export interface ICardProps {
  title: string;
  helpText?: React.ReactNode;
  total?: React.ReactNode;
  totalColor?: string;
  percent?: React.ReactNode;
  percentColor?: string;
}

const ValueCard = ({
  title,
  helpText,
  total,
  totalColor = '#78909C',
  percent,
  percentColor = '#37474F'
}: ICardProps) => {
  return (
    <div className='flex flex-col items-start rounded-lg bg-white px-4.25 py-3'>
      <header className='flex items-center'>
        <span className='text-xs font-semibold text-[#37474F]'>{title}</span>
        <Space axis='horizontal' size={9.25} />
        {helpText && <HelpTip text={helpText} />}
      </header>
      <div className='flex w-full items-end justify-between'>
        {total != null && (
          <span className='text-base' style={{ color: totalColor }}>
            {total}
          </span>
        )}
        {percent != null && (
          <span className='text-sm font-semibold' style={{ color: percentColor, height: 32 }}>
            {percent}%
          </span>
        )}
      </div>
    </div>
  );
};

export default ValueCard;
